






































import { Action, State, Getter } from "vuex-class";
import ContentMixin from "@/mixins/ContentMixin";
import { Component, Prop, Watch } from "vue-property-decorator";
import { IPassage, IQuestion } from "@/store/modules/content/types";
import LoadingMixin from "@/mixins/LoadingMixin";
import { mixins } from "vue-class-component";
import { IUSection, IAnswer, Answers } from "@/store/types";
import TestTake from "@/components/test/TestTake.vue";
import { Route, NavigationGuardNext } from "vue-router";
import { EventBus } from "@/EventBus";
import routeSwich from "@/services/RouteSwitch";
import { FlowStatus } from "@/store/modules/flow/types";

const namespace: string = "assessmentModule";

Component.registerHooks(["beforeRouteLeave", "beforeRouteEnter"]);

@Component({
  name: "assessment",
  components: {
    TestTake,
  },
  filters: {
    time: function(value: number, isOngoingSection: boolean) {
      const h = Math.floor((value % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000))
        .toString()
        .padStart(2, "0");

      const m = Math.floor((value % (60 * 60 * 1000)) / (60 * 1000))
        .toString()
        .padStart(2, "0");

      const s = Math.floor((value % (60 * 1000)) / 1000)
        .toString()
        .padStart(2, "0");

      return isOngoingSection
        ? `${h}:${m}:${s}`
        : `${value / 1000 / 60} minutes`;
    },
  },
})
export default class Assessment extends mixins(LoadingMixin, ContentMixin) {
  @Prop({ default: null })
  public subject!: string;

  @Prop({ default: null })
  public testNumber!: number;

  @Prop({ default: null })
  public number!: string;

  @Action("takeSection", { namespace: "flowModule" })
  public takeFlowSection!: (status: FlowStatus) => Promise<void>;

  @Action("finishSection", { namespace: "flowModule" })
  public finishFlowSection!: (subject: string) => Promise<void>;

  @Action("finishSection", { namespace })
  public finishSection!: any;

  @Action("takeSection", { namespace })
  public takeSection!: any;

  @Action("fetchContentQuestions", { namespace: "contentModule" })
  public fetchContentQuestions!: any;

  @Action("fetchContentPassages", { namespace: "contentModule" })
  public fetchContentPassages!: any;

  @Action("saveAnswers", { namespace })
  public saveAnswers!: any;

  @Action("saveAnswer", { namespace })
  public saveAnswer!: any;

  @State("section", { namespace })
  public section!: IUSection;

  @State("questions", { namespace: "contentModule" })
  public questions!: IQuestion[];

  @State("passages", { namespace: "contentModule" })
  public passages!: IPassage[];

  @Getter("isOngoingSection", { namespace })
  public isOngoingSection!: boolean;

  @Getter("sectionTime", { namespace })
  public sectionTime!: number;

  @Getter("hasExamRoom", { namespace: "authModule" })
  public hasExamRoomPermission!: boolean;

  @Getter("homeRoute", { namespace: "authModule" })
  public getHomeRoute!: string;

  @Getter("isOfflineTest", { namespace: "authModule" })
  public isOffline!: boolean;

  @Getter("isOfflineEntryStudent", { namespace: "authModule" })
  public isOfflineEntryStudent!: boolean;

  @Getter("hasToken", { namespace: "authModule" })
  public hasToken!: boolean;

  @Getter("isOnline")
  public isConnected!: boolean;

  private questionNum = 0;
  private prevQuestionNum = 0;
  private isSectionStarted = false;
  private isSectionPaused = false;
  private isSectionTimeout = false;
  private popupVisible = false;
  private popupTitle = "";
  private popupText = "";
  private popupButtons:
    | null
    | {
        type: string;
        label: string;
        event: string;
      }[] = null;
  private onPopupClose: any = () => ({});
  private onPopupConfirm: any = () => ({});

  get startButton(): string {
    return this.isOngoingSection ? "Continue Your Exam" : "Start Your Exam";
  }

  get question(): IQuestion | null {
    const question =
      this.questions && this.questions.find(q => q.num === this.questionNum);
    return question || null;
  }

  get prevQuestion(): IQuestion | null {
    const question =
      this.questions &&
      this.questions.find(q => q.num === this.prevQuestionNum);
    return question || null;
  }

  @Watch("questionNum", { immediate: true })
  public onQuestionNum(n: number, o: number) {
    EventBus.$emit("question:changed");
  }

  private popupReset(): void {
    this.popupVisible = false;
    this.popupText = "";
    this.popupTitle = "";
    this.popupButtons = null;
  }

  private async load() {
    this.$Progress.start();
    try {
      this.isLoading = true;

      const params = {
        subject: this.subject,
        testNumber: this.testNumber,
        number: this.number,
      };

      await this.takeSection(params);

      await Promise.all([
        this.fetchContentQuestions(this.section.section_id),
        this.fetchContentPassages(this.section.section_id),
      ]);

      this.setAnswerAndTimeSpent(this.section.answers);

      if (!this.isSectionStarted) {
        const { answers } = this.section || {};
        const lastQuestionAnswerNum =
          answers && +Object.keys(answers).reverse()[0];

        if (this.section) {
          this.questionNum = lastQuestionAnswerNum || 1;
          this.isSectionStarted = true;
        }
      }

      this.$Progress.finish();
    } catch (e) {
      this.isLoading = false;
      this.$Progress.fail();
      throw e;
    } finally {
      this.isLoading = false;
    }
  }

  public updated() {
    if (
      this.section &&
      this.section.hasOwnProperty("subject") &&
      this.section.subject === "Math"
    ) {
      // @ts-ignore
      window.MathJax.typeset();
    }
  }

  public async beforeMount() {
    window.addEventListener("beforeunload", this.notifyAppUnload);

    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.notifyAppUnload);
    });
  }

  public destroyed() {
    EventBus.$off("tool:choice");
  }

  public async beforeRouteEnter(
    to: Route,
    from: Route,
    next: NavigationGuardNext<Assessment>
  ) {
    next(async vm => {
      await vm.load();
    });
  }

  public async beforeRouteLeave(
    to: Route,
    from: Route,
    next: NavigationGuardNext<Assessment>
  ) {
    if (this.section.is_completed) {
      next();
      return;
    }
    this.popupText = "The section is not completed.";
    this.popupTitle = "Unfinished section";
    this.popupButtons = [
      {
        type: "danger",
        label: "Leave the test",
        event: "section:leave:click",
      },
    ];

    if (!this.hasToken) {
      next();
    } else {
      if (this.isOffline && this.isSectionStarted) {
        this.popupVisible = true;

        this.onPopupClose = () => {
          this.popupReset();
        };

        this.onPopupConfirm = async () => {
          this.popupReset();
          next();
        };
      } else if (this.isSectionStarted && !this.isSectionTimeout) {
        this.popupVisible = true;

        this.onPopupClose = () => {
          this.popupReset();
        };

        this.onPopupConfirm = async () => {
          this.popupReset();
          await next();
          await this.saveSectionProgress();
        };
      } else {
        next();
      }
    }
  }

  private async saveSectionProgress() {
    const { id, num } = this.question || {};
    const spentTime = (q: any) => q && (q.time_spent || 0) + 0;
    const studentAnswer = (q: any) => q && q.student_answer;

    if (this.section) {
      const answer = {
        usection_id: this.section.id,
        question_id: this.prevQuestion ? this.prevQuestion.id : id,
        question_num: this.prevQuestion ? this.prevQuestion.num : num,
        time_spent: spentTime(this.prevQuestion || this.question),
        time_remain: 0,
        answer: studentAnswer(this.prevQuestion || this.question),
      };

      if (answer.answer) {
        await this.saveAnswer(answer);
      }
    }
  }

  private setAnswerAndTimeSpent(answers: Answers) {
    for (const key in answers) {
      const question = this.questions.find(
        q => q.id === answers[key].question_id
      );

      if (question) {
        if (answers[key].answer) {
          this.$set(question, "student_answer", answers[key].answer);
        } else {
          this.$set(question, "student_answer", answers[key].answer_obj);
        }

        this.$set(question, "time_spent", answers[key].time_spent);
      }
    }
  }

  private async notifyAppUnload(event: any) {
    const shouldWarnningBeforeUnload =
      (this.isSectionStarted && !this.isSectionTimeout) ||
      (this.isOffline && this.isOfflineEntryStudent);

    const shouldSaveSectionProgress =
      this.isSectionStarted && !this.isSectionTimeout && !this.isOffline;

    if (shouldWarnningBeforeUnload) {
      event.preventDefault();
      event.returnValue = "";
    }

    if (shouldSaveSectionProgress) {
      await this.saveSectionProgress();
    }
  }

  private async handleSaveAnsware(ansawer: IAnswer): Promise<void> {
    await this.saveAnswer({
      ...ansawer,
      time_spent: 0,
      time_remain: 0,
    });
  }

  private async handleSectionFinish() {
    try {
      this.$Progress.start();
      await this.finishSection({
        usectionId: this.section.id,
        timeRemain: 0,
      });
      this.$Progress.finish();
    } catch (e) {
      this.$Progress.fail();
    }
  }

  private onChangeCurrentQuestion(num: number) {
    this.prevQuestionNum = this.questionNum;
    this.questionNum = num;
  }

  private async onSectionStarted() {
    if (this.isOngoingSection) {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      this.$nextTick(async () => {});
    }
  }

  private async onSectionFinished(): Promise<void> {
    this.$Progress.start();
    try {
      this.isLoading = true;

      await this.handleSectionFinish();
      this.$set(this.section, "is_completed", true);
      this.isSectionStarted = false;

      await this.finishFlowSection(this.section.subject);
      await this.$router.push(routeSwich.getRoute());
      this.$Progress.finish();
    } catch (e) {
      this.$Progress.fail();
      this.isLoading = false;
      this.isSectionStarted = true;
      this.$set(this.section, "is_completed", false);
      this.$notify({
        type: "error",
        duration: 2000,
        group: "error",
        title: "An error ocurred",
        text: "Try again latter",
      });
    }
  }
}
